import React, { FC } from 'react';
import Select from 'react-select';
import cx from 'classnames';

import { Base as Div } from 'styled';
import { Label, ErrorMessage, DropdownContainer } from './style';

import { ValueType } from 'react-select/src/types';
import { DropdownOption } from 'types';
import { Color } from 'styled/theme/colors';

export interface Props {
  id?: string;
  name: string;
  label?: string;
  className?: string;
  color?: Color;
  ariaLabel: string;
  onChange: (value: DropdownOption | null) => any;
  options: DropdownOption[];
  placeholder?: string;
  value?: DropdownOption | null;
  showLabel: boolean;
  errorMessage?: string;
  showError: boolean;
}

const defaultProps = {
  className: '',
  required: false,
  showLabel: false,
  showError: false,
};

const Dropdown: FC<Props> = ({
  id,
  ariaLabel,
  className,
  color,
  label,
  name,
  options,
  placeholder,
  value,
  showLabel,
  errorMessage,
  showError,
  onChange,
}) => {
  const handleOnChange = (option: ValueType<any>) => {
    if (!option) return;

    onChange(option);
  };

  const _id = id || name;

  return (
    <DropdownContainer
      className={cx('Dropdown', className)}
      showError={showError}
      color={color}
    >
      <Div position="relative">
        {label && (
          <Label
            as="label"
            htmlFor={_id}
            position="absolute"
            left={0}
            marginTop="-1rem"
            showLabel={showLabel}
          >
            {label}
          </Label>
        )}
        {errorMessage && (
          <Div display="flex" flexDirection="row-reverse">
            <ErrorMessage marginTop="-1rem" showLabel={showError} role="alert">
              {errorMessage}
            </ErrorMessage>
          </Div>
        )}
      </Div>
      <Select
        classNamePrefix="Select"
        name={name}
        options={options}
        isClearable={false}
        isSearchable={false}
        placeholder={placeholder}
        onChange={handleOnChange}
        aria-label={ariaLabel}
        value={value}
      />
    </DropdownContainer>
  );
};

Dropdown.defaultProps = defaultProps;

export default Dropdown;
